import { useAnalytics } from 'use-analytics';
import { useEffect } from 'react';
import useAuth from './hooks/useAuth';
import useClientQuery from './hooks/useClientQuery';
import useLoanApplicationQuery from './hooks/useLoanApplicationQuery';

const useIdentificationTracker = () => {
  const { emailOrPersonalId } = useAuth();
  const { data: clientData, status: clientStatus } = useClientQuery();
  const loanApplicationQuery = useLoanApplicationQuery();
  const { identify } = useAnalytics();

  useEffect(() => {
    if (clientStatus !== 'success' || !clientData) return;

    identify(emailOrPersonalId || '', { client: clientData });
  }, [
    clientStatus,
    clientData?.id,
    clientData?.number,
    clientData?.bankAccount,
    clientData?.identifiedBy,
    clientData?.registeredBy,
    clientData?.status,
    clientData?.newClient,
    clientData?.markedForManualIdentification,
    clientData?.hasOpenLoan,
  ]);

  useEffect(() => {
    if (
      loanApplicationQuery.status !== 'success' ||
      !loanApplicationQuery.loanApplication
    )
      return;

    identify(emailOrPersonalId || '', {
      application: loanApplicationQuery.loanApplication,
    });
  }, [
    loanApplicationQuery.status,
    loanApplicationQuery.loanApplication?.id,
    loanApplicationQuery.loanApplication?.amount,
    loanApplicationQuery.loanApplication?.term,
    loanApplicationQuery.loanApplication?.confirmed,
    loanApplicationQuery.loanApplication?.expired,
    loanApplicationQuery.loanApplication?.type,
    loanApplicationQuery.loanApplication?.typeDetail,
    loanApplicationQuery.loanApplication?.resolution,
    loanApplicationQuery.loanApplication?.resolutionDetail,
    loanApplicationQuery.loanApplication?.resolutionDetailMessage,
    loanApplicationQuery.loanApplication?.status,
    loanApplicationQuery.loanApplication?.closed,
  ]);
};

export default useIdentificationTracker;
